import { faSearch } from "@jewlr/pro-light-svg-icons/faSearch"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { Link, useLocation } from "react-router-dom"

import {
  clearSearchUserInput,
  clearSearchSuggestions,
} from "app-store-v2/app/actions"
import CartIcon from "areas/header/dropdowns/cart-icon"
import withHeader from "areas/header/hoc/with-header"
import NavIcon from "areas/header/nav-icon"
import WishlistIcon from "areas/header/portal/wishlist-icon"
import Button from "components/ui/button"
import Image from "components/ui/image"
import Media from "components/ui/media"
import { retry } from "helpers/application"

import DesktopMenu from "./menu/desktop"

const Search = loadable(() => retry(() => import("./search/search")), {
  ssr: false,
})

const DesktopNav = ({ toggleMenu }) => {
  const [showSearch, setShowSearch] = useState(false)
  const searchInputRef = useRef()
  const searchBtnRef = useRef()
  const restoreSearchFocus = useRef()

  const location = useLocation()
  const dispatch = useDispatch()
  const clearSearch = () => {
    dispatch(clearSearchUserInput())
    dispatch(clearSearchSuggestions())
  }

  useEffect(() => {
    toggleMenu(true)
    setShowSearch(false)
    clearSearch()
  }, [location.pathname])

  useEffect(() => {
    if (!showSearch && restoreSearchFocus.current && searchBtnRef.current) {
      searchBtnRef.current.focus()
      restoreSearchFocus.current = false
    }
  }, [showSearch, searchBtnRef.current])

  const toggleSearchBar = (e) => {
    e.preventDefault()
    setShowSearch(!showSearch)
    toggleMenu(true)
  }

  const handleCloseSearch = () => {
    restoreSearchFocus.current = true
    setShowSearch(false)
  }

  return (
    <Media
      className="contained-wide flex w-full items-center justify-between px-32"
      greaterThanOrEqual="desktop"
    >
      <div className="desktop:block basis-150 hidden shrink-0 grow">
        <Link className="inline-block" data-lc="home" to="/">
          <Image
            alt={sl.config.site_title}
            height="36"
            lazyload={false}
            src={require("images/logo/customize-your-jewelry-logo.svg")}
            width="141"
          />
        </Link>
      </div>
      <DesktopMenu />
      <div className="basis-160 widescreen:basis-200 relative flex shrink-0 grow items-center justify-end gap-24">
        {showSearch ? (
          <Search
            handleCloseSearch={handleCloseSearch}
            searchInputRef={searchInputRef}
          />
        ) : (
          <>
            <WishlistIcon />
            <Button
              aria-label="Search"
              className="inline-block"
              onClick={toggleSearchBar}
              ref={searchBtnRef}
            >
              <NavIcon icon={faSearch} />
            </Button>
            <CartIcon />
          </>
        )}
      </div>
    </Media>
  )
}

DesktopNav.propTypes = {
  toggleMenu: PropTypes.func,
}

export default withHeader(DesktopNav)
